import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";


const BlogDetails=()=>{

return (<>
 <div className="home">
                <div id="page" className="hfeed page-wrapper">
                    <Header />
                    <div id="site-main" className="site-main">
  <div id="main-content" className="main-content">
    <div id="primary" className="content-area">
      {/* <div id="title" className="page-title">
        <div className="section-container">
          <div className="content-title-heading">
            <h1 className="text-title-heading">
              Bridial Fair Collections 2025
            </h1>
          </div>
          <div className="breadcrumbs">
            <a href="/products">Home</a>
            <span className="delimiter" />
            Bridial Fair Collections 2025
          </div>
        </div>
      </div> */}
      <br></br>
      <div id="content" className="site-content" role="main">
        <div className="section-padding">
          <div className="section-container p-l-r">
            <div className="post-details no-sidebar">
              <div className="post-image">
                <img src="../assets/media/blog/1.jpg" alt="" />
              </div>
              <h2 className="post-title">Bridial Fair Collections 2025</h2>
              <div className="post-meta">
                <span className="post-categories">
                  <i className="icon_folder-alt" />{" "}
                  <a href="#0">Wedding &amp; Bridal</a>
                </span>
                <span className="post-time">
                  <i className="icon_clock_alt" /> July 24, 2025
                </span>
                <span className="post-comment">
                  <i className="icon_comment_alt" /> 1 Comment
                </span>
              </div>
              <div className="post-content clearfix">
                <p>
                  Sed mollis, eros et ultrices tempus, mauris ipsum aliquam
                  libero, non adipiscing dolor urna a orci. Aenean commodo
                  ligula eget dolor. Nulla facilisi. Sed mollis, eros et
                  ultrices tempus, mauris ipsum aliquam libero, non adipiscing
                  dolor urna a orci. non, velit. Etiam rhoncus. Nunc interdum
                  lacus sit amet orci. Phasellus leo dolor, tempus non, auctor
                  et, hendrerit quis, nisiVivamus aliquet elit ac nisl. Ut a
                  nisl id ante tempus hendrerit.Sed mollis, eros et ultrices
                  tempus, mauris ipsum aliquam libero, non adipiscing dolor urna
                  a orci. Aenean commodo ligula eget dolor. Nulla facilisi. Sed
                  mollis, eros et ultrices tempus, mauris ipsum aliquam libero,
                  non adipiscing dolor urna a orci. Duis arcu tortor, suscipit
                  eget, imperdiet nec, imperdiet iaculis, ipsum.
                </p>
                <p>
                  Proin sapien ipsum, porta a, auctor quis, euismod ut, mi.
                  Nulla neque dolor, sagittis eget, iaculis quis, molestie non,
                  velit. Etiam rhoncus. Nunc interdum lacus sit amet orci.
                  Phasellus leo dolor, tempus non, auctor et, hendrerit quis,
                  nisi.
                </p>
                <blockquote>
                  <p>
                    <i className="icon-straight-quotes" />
                    Vivamus aliquet elit ac nisl. Ut a nisl id ante tempus
                    hendrerit. Phasellus accumsan cursus velitid ante tempus
                    hendrerit. Donec interdum, metus et hendrerit aliquet”
                  </p>
                  <h2>ROBERT SMITH</h2>
                </blockquote>
                <p>
                  Sed mollis, eros et ultrices tempus, mauris ipsum aliquam
                  libero, non adipiscing dolor urna a orci. Aenean commodo
                  ligula eget dolor. Nulla facilisi. Sed mollis, eros et
                  ultrices tempus, mauris ipsum aliquam libero, non adipiscing
                  dolor urna a orci. Duis arcu tortor, suscipit eget, imperdiet
                  nec, imperdiet iaculis, ipsum.
                </p>
                <p>
                  Proin sapien ipsum, porta a, auctor quis, euismod ut, mi.
                  Nulla neque dolor, sagittis eget, iaculis quis, molestie non,
                  velit. Etiam rhoncus. Nunc interdum lacus sit amet orci.
                  Phasellus leo dolor, tempus non, auctor et, hendrerit quis,
                  nisi.
                </p>
                <div className="content-img">
                  <img
                    width={1410}
                    height={460}
                    src="../assets/media/blog/details.jpg"
                    alt=""
                  />
                </div>
              </div>
              <div className="post-content-entry">
                <div className="tags-links">
                  <label>Tags :</label>{" "}
                  <a href="#0" rel="tag">
                    Wedding
                  </a>{" "}
                  <a href="#0" rel="tag">
                    Glossary
                  </a>
                </div>
                <div className="entry-social-share">
                  <label>Share :</label>
                  <div className="social-share">
                    <a
                      href="#"
                      title="Facebook"
                      className="share-facebook"
                      target="_blank"
                    >
                      <i className="fa fa-facebook" />
                      Facebook
                    </a>
                    <a href="#" title="Twitter" className="share-twitter">
                      <i className="fa fa-twitter" />
                      Twitter
                    </a>
                    <a href="#" title="Pinterest" className="share-pinterest">
                      <i className="fa fa-pinterest" />
                      Pinterest
                    </a>
                  </div>
                </div>
              </div>
              <div className="prev-next-post">
                <div className="previous-post">
                  <a href="#0" rel="prev">
                    <div className="hover-extend active">
                      <span>Previous</span>
                    </div>
                    <h2 className="title">Our Sterling Silver</h2>
                  </a>
                </div>
                <div className="next-post">
                  <a href="#0" rel="next">
                    <div className="hover-extend active">
                      <span>Next</span>
                    </div>
                    <h2 className="title">New Season Modern Gold Earrings</h2>
                  </a>
                </div>
              </div>
              <div id="comments" className="comments-area">
                <h3 className="comments-title">1 Comment</h3>
                <div className="comments-list">
                  <div className="comment-item">
                    <div className="comment-avatar">
                      <img
                        alt=""
                        src="../assets/media/user.jpg"
                        className="avatar"
                        height={70}
                        width={70}
                      />
                    </div>
                    <div className="comment-content-wrap">
                      <h3 className="comment-author">Peter Capidal</h3>
                      <div className="comment-time">June 15, 2025</div>
                      <div className="comment-content">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Nam fringilla augue nec est tristique auctor.
                          Donec non est at libero vulputate rutrum. Morbi ornare
                          lectus quis justo gravida semper. Nulla tellus mi,
                          vulputate adipiscing cursus eu, suscipit id nulla.
                        </p>
                      </div>
                      <a className="comment-reply-link" href="#">
                        Reply
                      </a>
                    </div>
                  </div>
                </div>
                <div className="comment-form">
                  <div className="form-header">
                    <h3>Leave a Reply</h3>
                  </div>
                  <form action="" method="post" className="row" noValidate="">
                    <div className="comment-notes col-md-12 col-sm-12">
                      Your email address will not be published.
                    </div>
                    <div className="form-group col-md-12 col-sm-12">
                      <textarea
                        id="comment"
                        name="comment"
                        cols={45}
                        rows={8}
                        aria-required="true"
                        placeholder="Comment"
                        className="form-control"
                        defaultValue={""}
                      />
                    </div>
                    <div className="form-group col-md-6 col-sm-6">
                      <input
                        id="author"
                        placeholder="Your Name *"
                        name="author"
                        type="text"
                        defaultValue=""
                        size={30}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group col-md-6 col-sm-6">
                      <input
                        id="email"
                        placeholder="Your Email *"
                        name="email"
                        type="text"
                        defaultValue=""
                        size={30}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group col-md-12 col-sm-12">
                      <input
                        id="url"
                        name="url"
                        placeholder="Website"
                        type="text"
                        defaultValue=""
                        size={30}
                        className="form-control"
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <input
                        name="submit"
                        type="submit"
                        id="submit"
                        className="button button-outline border-black"
                        defaultValue="Post Comment"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* #content */}
    </div>
    {/* #primary */}
  </div>
  {/* #main-content */}
</div>

<Footer/>
</div>

</div>

</>)




}

export default BlogDetails;